var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.406a5.625 5.625 0 00-5.625 5.625v5.063H1.969a.844.844 0 100 1.687H16.03a.844.844 0 100-1.687h-1.406V7.03A5.625 5.625 0 009 1.406zM10.406 16.875a.844.844 0 000-1.688H7.594a.844.844 0 000 1.688h2.812z"
  }))));
}
export default __webpack_public_path__ + "static/noti.c9f4d89d.svg";
export { SvgNoti as ReactComponent };